<template>
  <table class="table table-sm">
    <thead>
      <tr>
        <th>Element</th>
        <th>Beschrijving</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="2" class="text-center font-weight-bold">Knoppen</td>
      </tr>
      <tr>
        <td><b-btn variant="primary">Actie</b-btn></td>
        <td>Actie ondernemen in nieuwe pagina of dialoogvenster</td>
      </tr>
      <tr>
        <td><b-btn variant="success">Actie</b-btn></td>
        <td>Actie dat iets toevoegt ondernemen in nieuwe pagina of dialoogvenster</td>
      </tr>
      <tr>
        <td><b-btn variant="outline-primary">Actie</b-btn></td>
        <td>Actie ondernemen op huidige pagina</td>
      </tr>
      <tr>
        <td><b-btn variant="danger">Actie</b-btn> </td>
        <td>Gevaarlijke actie bevestigen</td>
      </tr>
      <tr>
        <td><b-btn variant="info">Actie</b-btn> </td>
        <td>Gevaarlijke actie annuleren</td>
      </tr>
      <tr>
        <td><busy-btn :busy="true" variant="primary">Actie</busy-btn></td>
        <td>Actie wordt uitgevoerd</td>
      </tr>
      <tr>
        <td><busy-btn :progress="55" variant="primary" style="width: 4em">Actie</busy-btn></td>
        <td>Actie wordt uitgevoerd, 55% voltooid</td>
      </tr>
      <tr>
        <td><b-dropdown variant="outline-primary"/></td>
        <td>Dropdown menu met acties op de huidige pagina</td>
      </tr>
      <tr>
        <td><b-dropdown variant="primary"/></td>
        <td>Dropdown menu met acties op nieuwe pagina of dialoogvenster</td>
      </tr>
      <tr>
        <td colspan="2" class="text-center font-weight-bold">Pictogrammen</td>
      </tr>
      <tr>
        <td><span class="mdi mdi-open-in-new"/></td>
        <td>Actie opent in nieuw venster</td>
      </tr>
      <tr>
        <td><span class="mdi mdi-eye-outline" /></td>
        <td>Object bekijken</td>
      </tr>
      <tr>
        <td><span class="mdi mdi-pencil"/></td>
        <td>Object bewerken</td>
      </tr>
      <tr>
        <td><span class="mdi mdi-trash-can-outline" /></td>
        <td>Object verwijderen</td>
      </tr>
      <tr>
        <td><div class="sort-desc"></div></td>
        <td>Aflopend gesorteerd (z -> A, 9 -> 0)</td>
      </tr>
      <tr>
        <td><div class="sort-asc"></div></td>
        <td>Oplopend gesorteerd (A -> z, 0 -> 9)</td>
      </tr>
      <tr>
        <td colspan="2" class="text-center font-weight-bold">Andere</td>
      </tr>
      <tr>
        <td><span class="text-muted font-italic">Tekst</span></td>
        <td>Vervangende tekst voor iets dat niet aanwezig is of ongeweten gegeven (null)</td>
      </tr>
      <tr>
        <td><span class="text-success">Tekst</span></td>
        <td>Status indicatie van iets dat online, actief of beschikbaar is</td>
      </tr>
      <tr>
        <td><span class="text-danger">Tekst</span></td>
        <td>Status indicatie van iets dat offline, inactief of niet beschikbaar is</td>
      </tr>
    </tbody>

  </table>

</template>

<script>

import BusyBtn from '@/components/BusyBtn';

export default
{
    components: { BusyBtn }
}
</script>

<style>
.sort-desc
{
    background-position: right calc(0.75rem / 2) center;
    background-size: 0.65em 1em;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
    width: 1.5em;
    height: 1em;
}
.sort-asc
{
    background-position: right calc(0.75rem / 2) center;
    background-size: 0.65em 1em;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
    width: 1.5em;
    height: 1em;
}
</style>